import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import ReusableModal from '../../../../v2/MUI_custom_component/Modal/CustomModal';
import { CustomButton } from '../../../../v2/MUI_custom_component';

const ReusableOCRFailureModal = ({ 
    open, 
    onClose, 
    onTryAgain, 
    onEnterManually, 
    errorMessage,
    title = "Document Invalid",
    tryAgainText = "Try Again",
    enterManuallyText = "Enter Manually",
    maxWidth = "500px",
    showIcon = true,
    icon = WarningIcon,
    iconColor = "#ff9800",
    iconSize = 80
}) => {
    const IconComponent = icon;
    
    return (
        <ReusableModal
            open={open}
            onClose={onClose}
            title=""
            subtitle=""
            maxWidth={maxWidth}
            topMobile="20%"
            topDesktop="50%"
        >
            <Box sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                py: 2
            }}>
                {showIcon && IconComponent && (
                    <IconComponent sx={{ fontSize: iconSize, color: iconColor, mb: 2 }} />
                )}
                
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                    {title}
                </Typography>
                
                {errorMessage && (
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                        {errorMessage}
                    </Typography>
                )}
                
                <Stack direction={{ xs: 'column', sm: 'row' }} sx={{ width: '100%', gap: 2 }}>
                    <CustomButton
                        variant="outlined"
                        onClick={onTryAgain}
                        label={tryAgainText}
                        fullWidth
                        sx={{ order: { xs: 2, sm: 1 } }}
                    />
                    <CustomButton
                        variant="filled"
                        onClick={onEnterManually}
                        label={enterManuallyText}
                        fullWidth
                        sx={{ order: { xs: 1, sm: 2 } }}
                    />
                </Stack>
            </Box>
        </ReusableModal>
    );
};

export default ReusableOCRFailureModal;